module.exports = __webpack_public_path__ + "static/media/check.2b984022.svg";